import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, Modal } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import i18n from 'i18n-js';

const ReprintModal = ({ 
  visible, 
  onReprint, 
  onCancel, 
  duration = 20000,
  printType = 'label'
}) => {
  const [timeLeft, setTimeLeft] = useState(duration / 1000);
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    if (visible) {
      setIsVisible(true);
      setTimeLeft(duration / 1000);
      
      const autoCloseTimer = setTimeout(() => {
        handleClose();
      }, duration);

      const countdownTimer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(countdownTimer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearTimeout(autoCloseTimer);
        clearInterval(countdownTimer);
      };
    }
  }, [visible, duration]);

  const handleClose = () => {
    setIsVisible(false);
    onCancel();
  };

  const handleReprint = () => {
    setIsVisible(false);
    onReprint();
  };

  if (!isVisible) return null;

  return (
    <Modal
      transparent={true}
      visible={isVisible}
      animationType="fade"
    >
      <View style={{
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        paddingTop: 80,
        paddingRight: 20
      }}>
        <LinearGradient
          colors={['#FFB538', '#CF7C08']}
          style={{
            borderRadius: 10,
            padding: 15,
            width: 280,
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
            elevation: 5
          }}
        >
          <Text style={{
            fontSize: 16,
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            marginBottom: 10,
            fontFamily: 'Poppins_600SemiBold'
          }}>
            Reprint the {printType} if needed
          </Text>

          <Text style={{
            fontSize: 12,
            color: '#333',
            textAlign: 'center',
            marginBottom: 15,
            fontFamily: 'Poppins_400Regular'
          }}>
            Auto-closing in {timeLeft} seconds
          </Text>

          <View style={{
            flexDirection: 'row',
            gap: 10
          }}>
            <TouchableOpacity
              onPress={handleClose}
              style={{
                backgroundColor: '#666',
                paddingHorizontal: 15,
                paddingVertical: 8,
                borderRadius: 5,
                minWidth: 70
              }}
            >
              <Text style={{
                color: '#fff',
                fontSize: 14,
                fontWeight: 'bold',
                textAlign: 'center',
                fontFamily: 'Poppins_600SemiBold'
              }}>
                Cancel
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={handleReprint}
              style={{
                backgroundColor: '#2D445F',
                paddingHorizontal: 15,
                paddingVertical: 8,
                borderRadius: 5,
                minWidth: 70
              }}
            >
              <Text style={{
                color: '#fff',
                fontSize: 14,
                fontWeight: 'bold',
                textAlign: 'center',
                fontFamily: 'Poppins_600SemiBold'
              }}>
                Reprint
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export default ReprintModal;
